import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

import BetrBolt from '@/assets/icons/betr-small-payment';
import { RadioItem } from '@/components/RadioItem';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { common } from '@/styles/styles';

import { FANTASY_MONEY_PAYMENT_METHOD } from '../const';
import { PaymentMethod, PreferredPayment } from '../hooks/use-deposit-payment-methods';
import { paymentMethodStyles } from '../styles';

type AddPaymentMethodFantasyMoneyProps = {
    handleSelect: (method: PaymentMethod, preferredMethod?: PreferredPayment) => void;
    isSelected?: boolean;
};

export const AddPaymentMethodFantasyMoney = ({
    handleSelect,
    isSelected = false,
}: AddPaymentMethodFantasyMoneyProps) => {
    const { t } = useTranslation('transactions');

    return (
        <Pressable
            style={[
                paymentMethodStyles.listItem,
                paymentMethodStyles.lineItemBorder,
                common.row,
                common.alignCenter,
                common.justifySpaceBetween,
            ]}
            onPress={() => {
                BetrAnalytics.trackProductEvent(AnalyticsEvent.DEPOSIT_METHOD_FANTASY_MONEY);
                handleSelect(FANTASY_MONEY_PAYMENT_METHOD);
            }}
        >
            <Row flex={1} alignItems={'center'}>
                <Box
                    width={48}
                    height={36}
                    marginRight="s16"
                    borderWidth={1}
                    borderColor={ds.colorToken.border.strong}
                    borderRadius="r8"
                    alignItems="center"
                    justifyContent="center"
                >
                    <BetrBolt />
                </Box>
                <Box flex={1}>
                    <Text variant="bodyLarge" color={ds.colorToken.text.primary}>
                        {t('fantasy_money')}
                    </Text>
                    <Box>
                        <Text variant="bodyMedium" color="neutral300" numberOfLines={1}>
                            {t('fantasy_money_description')}
                        </Text>
                    </Box>
                </Box>
            </Row>
            <Box mr={'s10'}>
                <RadioItem selected={isSelected} />
            </Box>
        </Pressable>
    );
};
